import { type FC } from 'react';
import { ToolNavigationCollapsedTooltipLink } from './ToolNavigationCollapsedTooltipLink';
import { ChildNavigationItem } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/types';
import { PaddingBox } from '../../../../../ReactSharedScripts/components/PaddingBox';
import { urlToTestId } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/utils';
import { useToolNavigationActiveModuleProvider } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/components/ToolNavigationActiveModuleProvider';

type ToolNavigationCollapsedTooltipListProps = {
	moduleName: string;
	childNavigationItems: ChildNavigationItem[];
};

export const ToolNavigationCollapsedTooltipList: FC<ToolNavigationCollapsedTooltipListProps> = ({
	childNavigationItems,
}) => {
	const activePageTypeId = useToolNavigationActiveModuleProvider();

	return (
		<PaddingBox vrTiny>
			{childNavigationItems.map(({ pageTypeId, title, url }, index) => (
				<ToolNavigationCollapsedTooltipLink
					key={pageTypeId || index}
					title={title}
					url={url}
					isActive={activePageTypeId === pageTypeId}
					data-tool-navigation-module-link-name={urlToTestId(url)}
				/>
			))}
		</PaddingBox>
	);
};
